const mixin = {
	data: () => ({
		tooltipData: null,
		tooltipOffset: { x: 5, y: 5 },
		tooltipStyles: {
			left: 0 + 'px',
			top: 0 + 'px'
		}
	}),
	methods: {
		showTooltip(district, e) {
			if (e.type === 'mouseenter' && 'ontouchstart' in window) return false;
			// console.log(district)
			clearTimeout(this.tooltipTimeout);
			this.tooltipData = district;
			this.tooltip.classList.add('visible');
			this.moveTooltip(e);
		},
		moveTooltip(e) {
			this.tooltip.style.left = e.clientX + this.tooltipOffset.x + 'px';
			this.tooltip.style.top = e.clientY + this.tooltipOffset.y + 'px';
		},
		hideTooltip(e) {
			if (e.type === 'mouseleave' && ('ontouchstart' in window || (e.sourceCapabilities || {}).firesTouchEvents )) return false;
			// console.log('hideTooltip', e)
			this.tooltipTimeout = setTimeout(() => {
				this.tooltip.classList.remove('visible');
				this.districtData  = null;
			}, 10);

		}
	},
	mounted() {
		// console.log(this)
		try {
			document.createEvent("TouchEvent");
			this.TOUCH_DEVICE = true;
		} catch (e) {
			this.TOUCH_DEVICE = false;
		}
	}
};

export default mixin;



// WEBPACK FOOTER //
// ./src/mixins/tooltip.js